import {AfterViewInit, Component, OnDestroy, OnInit} from '@angular/core';
import {EmotionService} from '../../../../services/emotion/emotion.service';
import {CameraService} from '../../../../services/camera/camera.service';
import {FaceRecognitionService} from '../../../../services/face-recognition/face-recognition.service';

@Component({
  selector: 'app-camera-view',
  templateUrl: './camera-view.component.html',
  styleUrls: ['../../../../app.component.scss', './camera-view.component.scss']
})
export class CameraViewComponent implements OnInit, OnDestroy, AfterViewInit {
  canvasInterval: any;
  canvasImage?: HTMLCanvasElement;

  constructor(public emotionService: EmotionService,
              public faceRecognitionService: FaceRecognitionService,
              public cameraService: CameraService) {
  }

  ngOnInit() {
    this.canvasImage = document.getElementById('canvasLocalOutput') as HTMLCanvasElement;
    const videoElement = document.getElementById('localVideoElement') as HTMLVideoElement;

    this.cameraService.initVideoElement(videoElement);
    this.emotionService.setVariables(videoElement, this.canvasImage);
    this.startFocusCanvasInterval();
  }

  startFocusCanvasInterval() {
    this.stopFocusCanvasInterval();
    this.canvasInterval = setInterval(() => {
      if (this.canvasImage) {
        if (window.getComputedStyle(this.canvasImage).display === 'block') {
          this.canvasImage.focus();
        }
      }
    }, 1000);
  }

  stopFocusCanvasInterval() {
    if (this.canvasInterval) {
      clearInterval(this.canvasInterval);
    }
  }

  ngAfterViewInit(): void {
    setTimeout(() => {
      this.emotionService.loadModel(() => {
        /* const demoCanvas = document.getElementById('canvasLocalOutput') as HTMLCanvasElement;
         this.emotionService.initPredict(demoCanvas);*/
      });
    });
    this.cameraService.startCamera(() => {
      if (this.faceRecognitionService.classifiersLoadFinished) {
        this.emotionService.enableEmotionModeOn();
      }
    });
  }

  ngOnDestroy() {
    this.cameraService.stopCamera();
    this.emotionService.stopVideoDetection();
  }
}
